// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewModal-previewSliderContainer-sDWiD {
    max-width: 252px;
    margin: 0 auto;
    height: 527px;
    overflow-y: auto;
}

.PreviewModal-previewSliderImgContainer-NJItz,
.PreviewModal-previewSliderBorder-jYU_9 {
    border: 8px solid var(--slider-image-border-color);
    border-radius: 24px;
}

.PreviewModal-previewSliderImgContainer-NJItz {
    height: 527px;
    overflow-y: auto;
}

.PreviewModal-previewNoSliderImgContainer-g21W_ {
    width: 100%;
}

.PreviewModal-previewSliderImgContainer-NJItz img {
    width: 100%;
    border-radius: 12px;
    -o-object-fit: cover;
       object-fit: cover;
}

.PreviewModal-previewNoSliderImgContainer-g21W_ img {
    width: 100%;
    height: auto;
}

.PreviewModal-previewNoSliderImgContainer-g21W_:first-child img {
    border-radius: 12px 12px 0 0;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: top;
       object-position: top;
}

.PreviewModal-previewNoSliderImgContainer-g21W_:last-child img {
    border-radius: 0 0 12px 12px;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: bottom;
       object-position: bottom;
}

.PreviewModal-layoutSettingModalPopContainer-WB7H2 {
    max-width: 944px;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/IOSLayoutSettingsForm/PreviewModal/PreviewModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAiB;OAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,sBAAmB;OAAnB,mBAAmB;IACnB,uBAAoB;OAApB,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".previewSliderContainer {\n    max-width: 252px;\n    margin: 0 auto;\n    height: 527px;\n    overflow-y: auto;\n}\n\n.previewSliderImgContainer,\n.previewSliderBorder {\n    border: 8px solid var(--slider-image-border-color);\n    border-radius: 24px;\n}\n\n.previewSliderImgContainer {\n    height: 527px;\n    overflow-y: auto;\n}\n\n.previewNoSliderImgContainer {\n    width: 100%;\n}\n\n.previewSliderImgContainer img {\n    width: 100%;\n    border-radius: 12px;\n    object-fit: cover;\n}\n\n.previewNoSliderImgContainer img {\n    width: 100%;\n    height: auto;\n}\n\n.previewNoSliderImgContainer:first-child img {\n    border-radius: 12px 12px 0 0;\n    object-fit: contain;\n    object-position: top;\n}\n\n.previewNoSliderImgContainer:last-child img {\n    border-radius: 0 0 12px 12px;\n    object-fit: contain;\n    object-position: bottom;\n}\n\n.layoutSettingModalPopContainer {\n    max-width: 944px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewSliderContainer": `PreviewModal-previewSliderContainer-sDWiD`,
	"previewSliderImgContainer": `PreviewModal-previewSliderImgContainer-NJItz`,
	"previewSliderBorder": `PreviewModal-previewSliderBorder-jYU_9`,
	"previewNoSliderImgContainer": `PreviewModal-previewNoSliderImgContainer-g21W_`,
	"layoutSettingModalPopContainer": `PreviewModal-layoutSettingModalPopContainer-WB7H2`
};
module.exports = ___CSS_LOADER_EXPORT___;
